import { ArchiveVolume } from './archive-volume.model';
import { ArchiveVolumeRuleType } from './archive-volume-rule-type.enum';
import { ArchiveTitleRule } from './archive-title-rule.model';
export class BatchArchiveVolume extends ArchiveVolume {
  ruleType?: ArchiveVolumeRuleType;
  ruleCode?: string;
  titleRule?: ArchiveTitleRule = new ArchiveTitleRule();
}
